/**
 * @fileoverview Validation utility functions.
 */

import { logger } from "../logger";

/**
 * Log validation errors to console with helpful formatting.
 *
 * @param method - The SDK method that failed validation
 * @param errors - Array of error messages
 */
export function logValidationErrors(method: string, errors: string[]): void {
  logger.error(
    `Validation failed for ${method}:\n` +
      errors.map((e) => `  • ${e}`).join("\n"),
  );
}
